import { useParams } from 'react-router-dom';
import TownsData from '../../data/towns_data';
import HotelInList from './hotel';
import Banner from '../Header/banner';
import './hotels.css';

const Hotels = () => {

  const { townName } = useParams();

  return (
    <div >
      <Banner />
      <br />
      <div className='hotels-container'>
        <h1>{townName}</h1>
        
        {TownsData.map((town, index) => (
          town.name === townName && (
            <div>
            {town.information}
              
              <br/><br/>
              {town.routeInfo}
              <br /><br /><br />
              <h1>Bästa cykelhotellen i {townName}</h1>
              <br />
              {town.hotels.map((hotel, index) => (
                <HotelInList key={index} hotel={hotel} />
              ))}
            </div>
          )
        ))}
      </div>
    </div>
  );
}

export default Hotels;
